"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageMimeTypeToExtensionMap = exports.imageExtensions = exports.markdownEditorImageRegex = exports.extractMediaUrlFromRegexResult = void 0;
function extractMediaUrlFromRegexResult(regexResult) {
    var mediaUrlPrefix = "discuna-storage://";
    var urlStart = regexResult.indexOf(mediaUrlPrefix) + mediaUrlPrefix.length;
    return regexResult.slice(urlStart, -1);
}
exports.extractMediaUrlFromRegexResult = extractMediaUrlFromRegexResult;
exports.markdownEditorImageRegex = /!\[[^[\]]*]\(discuna-storage?:\/\/\S+\.(gif|jpeg|png|tif|wbmp|ico|jng|bmp|svg|webp)\)/g;
exports.imageExtensions = ["gif", "jpeg", "png", "tif", "wbmp", "ico", "jng", "bmp", "svg", "webp"];
exports.imageMimeTypeToExtensionMap = {
    "image/gif": "gif",
    "image/jpeg": "jpeg",
    "image/png": "png",
    "image/tiff": "tif",
    "image/vnd.wap.wbmp": "wbmp",
    "image/x-icon": "ico",
    "image/x-jng": "jng",
    "image/x-ms-bmp": "bmp",
    "image/svg+xml": "svg",
    "image/webp": "webp",
};
